import axios from 'axios';

let pendingIpRequest: Promise<{ data: { ip: string } }> | null = null;

export const getPublicIp = (): Promise<{ data: { ip: string } }> => {
  const cachedIp = sessionStorage.getItem('sawport-public-ip');
  if (cachedIp) return Promise.resolve({ data: { ip: cachedIp } });
  if (sessionStorage.getItem('sawport-public-ip-unavailable')) {
    return Promise.resolve({ data: { ip: '' } });
  }

  if (!pendingIpRequest) {
    pendingIpRequest = axios.get<{ ip: string }>('https://ipapi.co/json/')
      .then(({ data }) => {
        if (data.ip) sessionStorage.setItem('sawport-public-ip', data.ip);
        return { data: { ip: data.ip || '' } };
      })
      .catch(() => {
        sessionStorage.setItem('sawport-public-ip-unavailable', '1');
        return { data: { ip: '' } };
      })
      .finally(() => {
        pendingIpRequest = null;
      });
  }

  return pendingIpRequest;
};
